import { css, jsx } from '@emotion/core';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { bp, colors } from '@/styles';

import Components from './Components';

const style = {
  row: css`
    display: flex;
    width: 100%;
    flex-direction: column;
    @media ${bp.md} {
      margin: 0 auto;
      max-width: 832px;
      flex-direction: row;
      justify-content: space-between;
    }
  `,
  component: css`
    width: 100%;
    @media ${bp.md} {
      width: 50%;
    }
  `,
};
const HalfWidthParagraphCard = ({ blockData, entities }) => {
  return (
    <div css={style.row}>
      {blockData.Components &&
        Array.isArray(blockData.Components) &&
        blockData.Components.map(c => (
          <div css={style.component}>
            <Components componentData={entities.Components[c]} key={c} />
          </div>
        ))}
    </div>
  );
};

HalfWidthParagraphCard.propTypes = {};

export default HalfWidthParagraphCard;
